import { render, staticRenderFns } from "./LegalDocumentsLinks.vue?vue&type=template&id=dc1243ec&"
import script from "./LegalDocumentsLinks.vue?vue&type=script&lang=js&"
export * from "./LegalDocumentsLinks.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports